import { render, staticRenderFns } from "./ConsumablesListPrint.vue?vue&type=template&id=6b9858b1"
import script from "./ConsumablesListPrint.vue?vue&type=script&lang=js"
export * from "./ConsumablesListPrint.vue?vue&type=script&lang=js"
import style0 from "./ConsumablesListPrint.vue?vue&type=style&index=0&id=6b9858b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports